import { NodeSelection } from '@tiptap/pm/state';
import React from 'react';
import type { ExtensionProps, RicosExtension, RicosExtensionConfig } from 'ricos-types';

import { createRicosFunctionalExtension } from './create-ricos-extension';
import styles from './statics/styles.scss';

const setSelection = (editor, getPos) => {
  const selection = NodeSelection.create(editor.view.state.doc, (getPos as any)());
  const transaction = editor.view.state.tr.setSelection(selection);
  editor.view.dispatch(transaction);
};
const OverlayHoc = Component => {
  const Overlay = props => {
    return (
      <div
        className={styles.overlay}
        role="none"
        onClick={() => {
          setSelection(props.editor, props.getPos);
        }}
      >
        <Component {...props} />
      </div>
    );
  };
  Overlay.displayName = 'OverlayHoc';
  return Overlay;
};

export const overlay = createRicosFunctionalExtension({
  type: 'extension',
  name: 'overlay',
  groups: [],
  reconfigure: (
    config: RicosExtensionConfig,
    extensions: RicosExtension[],
    _props: ExtensionProps,
    settings: Record<string, unknown>
  ) => ({
    ...config,
    addOptions: () => settings,
    addNodeHoc: () => ({
      nodeTypes: extensions
        .filter(extension => extension.groups.includes('overlay'))
        .map(({ name }) => name),
      priority: 10,
      nodeHoc: OverlayHoc,
    }),
  }),
  createExtensionConfig() {
    return {
      name: this.name,
      priority: 10,
    };
  },
});
